<template>
  <div
    v-if="$store.getters.adblockDetected"
    class="c-player-popup"
    :class="[ isEmbedded ? 'c-player-popup--dark' : 'c-player-popup--light' ]"
  >
    <div
      v-if="isEmbedded"
      class="c-player-popup__container"
    >
      <i
        class="o-icon o-icon--sad-face"
        :class="[ isEmbedded || isMobile ? 'o-icon--xlarge' : 'o-icon--xxlarge']"
      ></i>
      <p
        v-dompurify-html="$t('player.adblock.shortDescription')"
        class="o-typography__headline4 u-mt-15"
      ></p>
    </div>
    <div
      v-else
      class="c-player-popup__container"
    >
      <i
        class="o-icon o-icon--sad-face"
        :class="[ isEmbedded || isMobile ? 'o-icon--xlarge' : 'o-icon--xxlarge']"
      ></i>
      <p class="o-typography__headline2 u-bold">
        {{ $t('player.adblock.header') }}
      </p>
      <div class="o-separator o-separator--highlight o-separator--center u-mt-5"></div>
      <p class="o-typography__headline4 u-mt-5">
        {{ $t('player.adblock.message') }}
      </p>
      <p
        v-dompurify-html="$t('player.adblock.description')"
        class="o-typography__headline4 u-mt-15"
      ></p>
    </div>
  </div>
</template>
<script>
  export default {
    computed: {
      isEmbedded() {
        return this.$parent.isEmbedded;
      },
      isMobile() {
        return this.$window.isMobileView;
      },
    },
  };
</script>
